export const Validator = {
  phone: (value?: string): string | null => {
    if (!value || value.trim() === '') return 'Please enter your phone number.';
    const digits = value.replace(/\D/g, '');
    if (digits.length < 7) return 'Please enter a valid phone number.';
    return null;
  },
  email: (value?: string): string | null => {
    if (!value || value.trim() === '') return 'Please enter your email.';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return 'Please enter a valid email.';
    return null;
  },
  firstname: (value?: string): string | null => {
    if (!value || value.trim() === '') return 'Please enter your first name.';
    if (value.trim().length < 2) return 'First name must be at least 2 characters.';
    return null;
  },
  surname: (value?: string): string | null => {
    if (!value || value.trim() === '') return 'Please enter your last name.';
    if (value.trim().length < 2) return 'Last name must be at least 2 characters.';
    return null;
  },
  id: (value?: string): string | null => {
    if (!value || value.trim() === '') return 'Please enter your National ID.';
    return null;
  },
};

export const formatGhanaCard = (value: string): string => {
  let v = value.toUpperCase().replace(/[^A-Z0-9-]/g, '');
  // Auto-insert first dash after 3 alpha chars
  if (v.length === 3 && /^[A-Z]{3}$/.test(v)) {
    v = v + '-';
  }
  // Auto-insert second dash after 12 chars (ABC-123456789)
  if (v.length === 13 && /^[A-Z]{3}-[0-9]{9}$/.test(v)) {
    v = v + '-';
  }
  return v;
};
